import { serviceCreate, merge } from "./modules/request";
//这种方式可以采用单个项目的接口，也可以使用多个项目的接口，看自己的项目情况而定
let http = serviceCreate({
  baseURL: "https://dev.chuichuiai.com/index.php",
  timeout: 60000, //请求超时
  emulateJSON: true //默认表单提交
});


//飞书登录
// export function fsAuth(params, config) {
//   return http.post(
//     "/fsapi/login/fsAuth",
//     params,
//     merge(config, { emulateJSON: false })
//   );
// }

// export function xfxAuth(params, config) {
//   return http.post(
//     "/fsapi/login/xfx_auth",
//     params,
//     merge(config, { emulateJSON: false })
//   );
// }
export function login(params, config) {
  return http.post(
    "/api/login/mobile",
    params,
    merge(config, { emulateJSON: false })
  );
}
//验证码获取
export function captcha(params, config) {
  return http.post(
    "/api/register/mobileCode",
    params,
    merge(config, { emulateJSON: false })
  );
}
export function invitationVerify(params, config) {
  return http.post(
    "/api/register/invitationVerify",
    params,
    merge(config, { emulateJSON: false })
  );
}
//上传Base64图片
export function uploadBase64(params, config) {
  return http.post(
    "/api/upload/headimgBase64",
    params,
    merge(config, { emulateJSON: false })
  );
}

export function templatePage(params, config) {
  return http.get("/api/template/lists", merge(config, { params }));
}

//素材分类
export function sourceMaterialClass(params, config) {
  return http.get("/api/sourcematerial/classlists", merge(config, { params }));
}

//素材列表
export function sourceMaterialList(params, config) {
  return http.get("/api/sourcematerial/lists", merge(config, { params }));
}

//设置素材使用日志
export function setSourceMaterialLog(params, config) {
  return http.post(
    "/api/sourcematerial/set_use",
    params,
    merge(config, { emulateJSON: false })
  );
}

export function uploadSourceMaterial(params, config) {
  return http.post(
    "/api/sourcematerial/upload_sc",
    params,
    merge(config, { emulateJSON: false })
  );
}

export function uploadPrompt(params, config) {
  return http.post(
    "/api/sourcematerial/upload_prompt",
    params,
    merge(config, { emulateJSON: false })
  );
}

export function delMySourceMaterial(params, config) {
  return http.post(
    "/api/sourcematerial/del_material",
    params,
    merge(config, { emulateJSON: false })
  );
}


//获取图片名称
export function getImageName(params, config) {
  return http.get("/api/gif/create_name", merge(config, { params }));
}

//获取背景列表
export function getbgLists(params, config) {
  return http.get("/api/sourcematerial/bg_lists", merge(config, { params }));
}

export function uploadImage(params, config) {
  return http.post(
    "/api/gif/upload_image",
    params,
    merge(config, { emulateJSON: false })
  );
}
export function getGuide(params, config) {
  return http.get("/api/gif/get_guide", merge(config, { params }));
}
export function setGuide(params, config) {
  return http.post(
    "/api/gif/guide",
    params,
    merge(config, { emulateJSON: false })
  );
}

export function evaluate(params, config) {
  return http.post(
    "/api/member/evaluate",
    params,
    merge(config, { emulateJSON: false })
  );
}

export function memberDraft(params, config) {
  return http.post(
    "/api/gif/member_draft",
    params,
    merge(config, { emulateJSON: false })
  );
}

export function getTexts(params, config) {
  return http.get("/api/gif/texts", merge(config, { params }));
}



export function getGifPage(params, config) {
  return http.get("/api/gif/page", merge(config, { params }));
}

export function verifyText(params, config) {
  return http.post(
    "/api/gif/text_verify",
    params,
    merge(config, { emulateJSON: false })
  );
}

export function findEmoji(params, config) {
  return http.post(
    "/api/gif/find_image",
    params,
    merge(config, { emulateJSON: false })
  );
}

export function setEmoji(params, config) {
  return http.post(
    "/api/gif/set_type",
    params,
    merge(config, { emulateJSON: false })
  );
}

export function setEmojiLike(params, config) {
  return http.post(
    "/api/gif/set_like",
    params,
    merge(config, { emulateJSON: false })
  );
}

export function getNotice(params, config) {
  return http.get("/api/notice/page", merge(config, { params }));
}

export function markNoticeRead(params, config) {
  return http.post(
    "/api/notice/mark_notice_read",
    params,
    merge(config, { emulateJSON: false })
  );
}

export function getNoticeAd(params, config) {
  return http.get("/api/notice/notice_ad", merge(config, { params }));
}

export function setAiCrateChat(params, config) {
  return http.post(
    "/api/gif/ai_create",
    params,
    merge(config, { emulateJSON: false })
  );
}

export function getAiVideo(params, config) {
  return http.get("/api/gif/get_ai_video", merge(config, { params }));
}

export function getVideoChatpage(params, config) {
  return http.get("/api/gif/get_chat_page", merge(config, { params }));
}

export function getMyImage(params, config) {
  return http.get("/api/member/image", merge(config, { params }));
}

export function getMyVideo(params, config) {
  return http.get("/api/member/video", merge(config, { params }));
}






// WEBPACK FOOTER //
// ./src/api/api.js